import React, { memo } from "react";
import { SvgIcon } from "@mui/material";
import { IIconProps } from "@/models";

const OverviewsIcon = ({ sx, ...otherProps }: IIconProps) => {
  return (
    <SvgIcon
      viewBox="0 0 24 24"
      sx={{
        fontSize: "inherit",
        ...sx,
      }}
      {...otherProps}
    >
      <g clipPath="url(#clip0_1940_2885)">
        <path
          d="M22 14.5C22.28 14.5 22.5 14.72 22.5 15V22C22.5 22.28 22.28 22.5 22 22.5H15C14.72 22.5 14.5 22.28 14.5 22V15C14.5 14.72 14.72 14.5 15 14.5H22ZM22 13H15C13.9 13 13 13.9 13 15V22C13 23.1 13.9 24 15 24H22C23.1 24 24 23.1 24 22V15C24 13.9 23.1 13 22 13Z"
          fill="currentColor"
        />
        <path
          d="M22 1.5C22.28 1.5 22.5 1.72 22.5 2V9C22.5 9.28 22.28 9.5 22 9.5H15C14.72 9.5 14.5 9.28 14.5 9V2C14.5 1.72 14.72 1.5 15 1.5H22ZM22 0H15C13.9 0 13 0.9 13 2V9C13 10.1 13.9 11 15 11H22C23.1 11 24 10.1 24 9V2C24 0.9 23.1 0 22 0Z"
          fill="currentColor"
        />
        <path
          d="M9 14.5C9.28 14.5 9.5 14.72 9.5 15V22C9.5 22.28 9.28 22.5 9 22.5H2C1.72 22.5 1.5 22.28 1.5 22V15C1.5 14.72 1.72 14.5 2 14.5H9ZM9 13H2C0.9 13 0 13.9 0 15V22C0 23.1 0.9 24 2 24H9C10.1 24 11 23.1 11 22V15C11 13.9 10.1 13 9 13Z"
          fill="currentColor"
        />
        <path
          d="M9 1.5C9.28 1.5 9.5 1.72 9.5 2V9C9.5 9.28 9.28 9.5 9 9.5H2C1.72 9.5 1.5 9.28 1.5 9V2C1.5 1.72 1.72 1.5 2 1.5H9ZM9 0H2C0.9 0 0 0.9 0 2V9C0 10.1 0.9 11 2 11H9C10.1 11 11 10.1 11 9V2C11 0.9 10.1 0 9 0Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_1940_2885">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
};

export default memo(OverviewsIcon);
